export default __webpack_public_path__ + "static/media/image14.6dd0469e.jpg";